import { StyledSvg } from "baseui/icon";
import React from "react";

export const UsageBillingTemplateIcon = (props: React.ComponentProps<typeof StyledSvg>) => (
  <StyledSvg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0.667969 4C0.667969 1.79086 2.45883 0 4.66797 0H16.668C18.8771 0 20.668 1.79086 20.668 4V16C20.668 18.2091 18.8771 20 16.668 20H4.66797C2.45883 20 0.667969 18.2091 0.667969 16V4Z"
      fill="#F8FFF0"
    />
    <path
      d="M7.1687 8.00398C7.1687 7.35865 6.6457 6.83565 6.00036 6.83565C5.35503 6.83565 4.83203 7.35865 4.83203 8.00398C4.83203 8.55698 4.83203 14.4483 4.83203 15.0007C4.83203 15.646 5.35503 16.169 6.00036 16.169C6.6457 16.169 7.1687 15.646 7.1687 15.0007C7.1687 14.448 7.1687 8.55665 7.1687 8.00398Z"
      fill="#558B2E"
    />
    <path
      d="M11.837 11.0023C11.837 10.357 11.314 9.83398 10.6687 9.83398C10.0234 9.83398 9.50037 10.357 9.50037 11.0023C9.50037 11.5553 9.50037 14.4483 9.50037 15.0007C9.50037 15.646 10.0234 16.169 10.6687 16.169C11.314 16.169 11.837 15.646 11.837 15.0007C11.837 14.448 11.837 11.5553 11.837 11.0023Z"
      fill="#558B2E"
    />
    <path
      d="M16.502 5.00232C16.502 4.35698 15.979 3.83398 15.3337 3.83398C14.6884 3.83398 14.1654 4.35698 14.1654 5.00232C14.1654 5.55532 14.1654 14.4483 14.1654 15.0007C14.1654 15.646 14.6884 16.169 15.3337 16.169C15.979 16.169 16.502 15.646 16.502 15.0007C16.502 14.448 16.502 5.55532 16.502 5.00232Z"
      fill="#558B2E"
    />
  </StyledSvg>
);
